export default __webpack_public_path__ + "static/media/Background-Portal-Mobile.485822ba.jpg";